<div class="fb-dialog">
  <h2 mat-dialog-title class="fb-dialog__title">{{ 'MODAL.CONFIRM_TITLE' | translate:{titulo: data.titulo} }}</h2>

  <p class="fb-confirm__message">{{ 'MODAL.CONFIRM_MSG' | translate }}</p>

  <mat-dialog-actions class="fb-dialog__actions">
    <button type="button" class="fb-btn fb-btn--ghost" (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
    <button type="button" class="fb-btn fb-btn--primary" (click)="finish()">{{ 'COMMON.CONFIRM' | translate }}</button>
  </mat-dialog-actions>
</div>
